import React, { Component } from "react";
import { connect } from "react-redux";
import ResetPasswordView from "./reset-password-view";
import { resetPassword } from "./reset-password-actions";
import ResetConfirmView from "./reset-confirm-view";
import { resetConfirm } from "./reset-confirm-actions";
import Utils from "../../library/utils";

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(location.search);
    const guid = params.get("resetGuid");
    window.history.replaceState(null, null, window.location.pathname);
    this.state = {
      email: props.auth.rememberedEmail,
      emailSentStatus: false,
      passwordResetSuccessfully: false,
      isResetConfirm: guid !== null,
      guid,
      password: "",
      confirmPassword: ""
    };
  }

  onChangeEmail = e => {
    this.setState({ email: e.target.value });
  };

  onChangePassword = e => {
    this.setState({ password: e.target.value });
  };

  onChangeConfirmPassword = e => {
    this.setState({ confirmPassword: e.target.value });
  };

  resetPassword = () => {
    this.props.resetPassword(this.state.email, () => {
      this.setState({ emailSentStatus: true });
    });
  };

  resetConfirm = () => {
    const { guid, password } = this.state;
    this.props.resetConfirm(password, guid, () => {
      this.setState({ passwordResetSuccessfully: true });
    });
  };

  handleKeyDown = e => {
    if (e.key === "Enter") {
      if (this.state.isResetConfirm) {
        this.resetConfirm();
      } else {
        this.resetPassword();
      }
    }
  };

  render() {
    const {
      password,
      confirmPassword,
      isResetConfirm,
      email,
      emailSentStatus,
      passwordResetSuccessfully
    } = this.state;

    if (isResetConfirm) {
      return (
        <ResetConfirmView
          {...this.props}
          resetConfirm={this.resetConfirm}
          password={password}
          confirmPassword={confirmPassword}
          onChangePassword={this.onChangePassword}
          onChangeConfirmPassword={this.onChangeConfirmPassword}
          disabled={
            !Utils.isValidPassword(password) ||
            !Utils.isValidPassword(confirmPassword) ||
            password !== confirmPassword
          }
          passwordResetSuccessfully={passwordResetSuccessfully}
          handleKeyDown={this.handleKeyDown}
        />
      );
    }

    return (
      <ResetPasswordView
        {...this.props}
        resetPassword={this.resetPassword}
        email={email}
        onChangeEmail={this.onChangeEmail}
        disabled={!Utils.isValidEmail(email) || emailSentStatus}
        emailSentStatus={emailSentStatus}
        handleKeyDown={this.handleKeyDown}
      />
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = {
  resetPassword: resetPassword,
  resetConfirm: resetConfirm
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/reset-password/reset-password.js